import { useState, useCallback } from 'react';
import { useTracking } from 'react-tracking';

import UserOutline from '@simplywallst/ui-core/icons/UserOutline';

import { Modal } from '@simplywallst/ui-core';

import { Wrapper, UserButton } from './styled';
import MenuOverlay from '../MenuOverlay/MenuOverlay';

enum ShowOverlay {
  VISIBLE = 'visible',
  HIDDEN = 'hidden',
}
const UserAccess = () => {
  const { trackEvent } = useTracking();
  const [showOverlay, setShowOverlay] = useState<ShowOverlay>(
    ShowOverlay.HIDDEN
  );

  const handleOpen = useCallback(() => {
    setShowOverlay(ShowOverlay.VISIBLE);
    trackEvent({
      modifier: 'more',
      action: 'open',
    });
  }, []);

  const handleClose = useCallback(() => {
    trackEvent({
      type: 'track',
      subject: 'primaryNavMobileFooterDraw',
      action: 'close',
    });
    setShowOverlay(ShowOverlay.HIDDEN);
  }, [trackEvent]);

  return (
    <Wrapper>
      <UserButton onClick={handleOpen} data-cy-id="mobile-more-menu">
        <UserOutline />
      </UserButton>
      {showOverlay === ShowOverlay.VISIBLE && (
        <Modal isNaked>
          <MenuOverlay onClose={handleClose} />
        </Modal>
      )}
    </Wrapper>
  );
};

export default UserAccess;
